export default __webpack_public_path__ + "static/media/icon-elearning-circle-solid.29963be7.svg";